/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponseOfArrivalsResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfCalloffsResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfDepartureReportResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfGetDashboardOpenshiftsResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIListOfHppdHoursResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIListOfOverVsUnderByPositionResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIListOfOverVsUnderResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfPendingAbsenceRequestsCountResponse } from '../api-models';
// @ts-ignore
import { OverVsUnderByPositionRequest } from '../api-models';
/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {string} [payDate] 
         * @param {number} [positionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardArrivalsGet: async (departmentId?: number, facilityId?: number, payDate?: string, positionId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Dashboard/arrivals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} [departmentId] 
         * @param {number} [positionId] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardCalloffsGet: async (startDate: string, endDate: string, departmentId?: number, positionId?: number, employeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('dashboardCalloffsGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('dashboardCalloffsGet', 'endDate', endDate)
            const localVarPath = `/Dashboard/calloffs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {string} [payDate] 
         * @param {number} [positionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardDeparturesGet: async (departmentId?: number, facilityId?: number, payDate?: string, positionId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Dashboard/departures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (payDate !== undefined) {
                localVarQueryParameter['payDate'] = (payDate as any instanceof Date) ?
                    (payDate as any).toISOString() :
                    payDate;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [positionId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardHppdHoursGet: async (departmentId?: number, facilityId?: number, positionId?: number, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Dashboard/HppdHours`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OverVsUnderByPositionRequest} [overVsUnderByPositionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardOverVsUnderByPositionPost: async (overVsUnderByPositionRequest?: OverVsUnderByPositionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Dashboard/OverVsUnder-by-position`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(overVsUnderByPositionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardOverVsUnderGet: async (startDate: string, endDate: string, departmentId?: number, facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('dashboardOverVsUnderGet', 'startDate', startDate)
            // verify required parameter 'endDate' is not null or undefined
            assertParamExists('dashboardOverVsUnderGet', 'endDate', endDate)
            const localVarPath = `/Dashboard/OverVsUnder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [positionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardPendingAbsenceRequestsCountGet: async (departmentId?: number, facilityId?: number, positionId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Dashboard/PendingAbsenceRequestsCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {string} [positionId] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardPendingOpenshiftApprovalsGet: async (departmentId?: number, positionId?: string, version?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Dashboard/PendingOpenshiftApprovals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {string} [payDate] 
         * @param {number} [positionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardArrivalsGet(departmentId?: number, facilityId?: number, payDate?: string, positionId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfArrivalsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardArrivalsGet(departmentId, facilityId, payDate, positionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} [departmentId] 
         * @param {number} [positionId] 
         * @param {number} [employeeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardCalloffsGet(startDate: string, endDate: string, departmentId?: number, positionId?: number, employeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfCalloffsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardCalloffsGet(startDate, endDate, departmentId, positionId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {string} [payDate] 
         * @param {number} [positionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardDeparturesGet(departmentId?: number, facilityId?: number, payDate?: string, positionId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfDepartureReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardDeparturesGet(departmentId, facilityId, payDate, positionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [positionId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardHppdHoursGet(departmentId?: number, facilityId?: number, positionId?: number, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIListOfHppdHoursResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardHppdHoursGet(departmentId, facilityId, positionId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {OverVsUnderByPositionRequest} [overVsUnderByPositionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardOverVsUnderByPositionPost(overVsUnderByPositionRequest?: OverVsUnderByPositionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIListOfOverVsUnderByPositionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardOverVsUnderByPositionPost(overVsUnderByPositionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardOverVsUnderGet(startDate: string, endDate: string, departmentId?: number, facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIListOfOverVsUnderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardOverVsUnderGet(startDate, endDate, departmentId, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [positionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardPendingAbsenceRequestsCountGet(departmentId?: number, facilityId?: number, positionId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfPendingAbsenceRequestsCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardPendingAbsenceRequestsCountGet(departmentId, facilityId, positionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [departmentId] 
         * @param {string} [positionId] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardPendingOpenshiftApprovalsGet(departmentId?: number, positionId?: string, version?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfGetDashboardOpenshiftsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardPendingOpenshiftApprovalsGet(departmentId, positionId, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {DashboardApiDashboardArrivalsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardArrivalsGet(requestParameters: DashboardApiDashboardArrivalsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfArrivalsResponse> {
            return localVarFp.dashboardArrivalsGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.payDate, requestParameters.positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiDashboardCalloffsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardCalloffsGet(requestParameters: DashboardApiDashboardCalloffsGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfCalloffsResponse> {
            return localVarFp.dashboardCalloffsGet(requestParameters.startDate, requestParameters.endDate, requestParameters.departmentId, requestParameters.positionId, requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiDashboardDeparturesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardDeparturesGet(requestParameters: DashboardApiDashboardDeparturesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfDepartureReportResponse> {
            return localVarFp.dashboardDeparturesGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.payDate, requestParameters.positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiDashboardHppdHoursGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardHppdHoursGet(requestParameters: DashboardApiDashboardHppdHoursGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIListOfHppdHoursResponse> {
            return localVarFp.dashboardHppdHoursGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiDashboardOverVsUnderByPositionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardOverVsUnderByPositionPost(requestParameters: DashboardApiDashboardOverVsUnderByPositionPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIListOfOverVsUnderByPositionResponse> {
            return localVarFp.dashboardOverVsUnderByPositionPost(requestParameters.overVsUnderByPositionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiDashboardOverVsUnderGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardOverVsUnderGet(requestParameters: DashboardApiDashboardOverVsUnderGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIListOfOverVsUnderResponse> {
            return localVarFp.dashboardOverVsUnderGet(requestParameters.startDate, requestParameters.endDate, requestParameters.departmentId, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiDashboardPendingAbsenceRequestsCountGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardPendingAbsenceRequestsCountGet(requestParameters: DashboardApiDashboardPendingAbsenceRequestsCountGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfPendingAbsenceRequestsCountResponse> {
            return localVarFp.dashboardPendingAbsenceRequestsCountGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiDashboardPendingOpenshiftApprovalsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardPendingOpenshiftApprovalsGet(requestParameters: DashboardApiDashboardPendingOpenshiftApprovalsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfGetDashboardOpenshiftsResponse> {
            return localVarFp.dashboardPendingOpenshiftApprovalsGet(requestParameters.departmentId, requestParameters.positionId, requestParameters.version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for dashboardArrivalsGet operation in DashboardApi.
 * @export
 * @interface DashboardApiDashboardArrivalsGetRequest
 */
export interface DashboardApiDashboardArrivalsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardArrivalsGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardArrivalsGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {string}
     * @memberof DashboardApiDashboardArrivalsGet
     */
    readonly payDate?: string

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardArrivalsGet
     */
    readonly positionId?: number
}

/**
 * Request parameters for dashboardCalloffsGet operation in DashboardApi.
 * @export
 * @interface DashboardApiDashboardCalloffsGetRequest
 */
export interface DashboardApiDashboardCalloffsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DashboardApiDashboardCalloffsGet
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof DashboardApiDashboardCalloffsGet
     */
    readonly endDate: string

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardCalloffsGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardCalloffsGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardCalloffsGet
     */
    readonly employeeId?: number
}

/**
 * Request parameters for dashboardDeparturesGet operation in DashboardApi.
 * @export
 * @interface DashboardApiDashboardDeparturesGetRequest
 */
export interface DashboardApiDashboardDeparturesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardDeparturesGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardDeparturesGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {string}
     * @memberof DashboardApiDashboardDeparturesGet
     */
    readonly payDate?: string

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardDeparturesGet
     */
    readonly positionId?: number
}

/**
 * Request parameters for dashboardHppdHoursGet operation in DashboardApi.
 * @export
 * @interface DashboardApiDashboardHppdHoursGetRequest
 */
export interface DashboardApiDashboardHppdHoursGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardHppdHoursGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardHppdHoursGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardHppdHoursGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {string}
     * @memberof DashboardApiDashboardHppdHoursGet
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof DashboardApiDashboardHppdHoursGet
     */
    readonly endDate?: string
}

/**
 * Request parameters for dashboardOverVsUnderByPositionPost operation in DashboardApi.
 * @export
 * @interface DashboardApiDashboardOverVsUnderByPositionPostRequest
 */
export interface DashboardApiDashboardOverVsUnderByPositionPostRequest {
    /**
     * 
     * @type {OverVsUnderByPositionRequest}
     * @memberof DashboardApiDashboardOverVsUnderByPositionPost
     */
    readonly overVsUnderByPositionRequest?: OverVsUnderByPositionRequest
}

/**
 * Request parameters for dashboardOverVsUnderGet operation in DashboardApi.
 * @export
 * @interface DashboardApiDashboardOverVsUnderGetRequest
 */
export interface DashboardApiDashboardOverVsUnderGetRequest {
    /**
     * 
     * @type {string}
     * @memberof DashboardApiDashboardOverVsUnderGet
     */
    readonly startDate: string

    /**
     * 
     * @type {string}
     * @memberof DashboardApiDashboardOverVsUnderGet
     */
    readonly endDate: string

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardOverVsUnderGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardOverVsUnderGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for dashboardPendingAbsenceRequestsCountGet operation in DashboardApi.
 * @export
 * @interface DashboardApiDashboardPendingAbsenceRequestsCountGetRequest
 */
export interface DashboardApiDashboardPendingAbsenceRequestsCountGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardPendingAbsenceRequestsCountGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardPendingAbsenceRequestsCountGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardPendingAbsenceRequestsCountGet
     */
    readonly positionId?: number
}

/**
 * Request parameters for dashboardPendingOpenshiftApprovalsGet operation in DashboardApi.
 * @export
 * @interface DashboardApiDashboardPendingOpenshiftApprovalsGetRequest
 */
export interface DashboardApiDashboardPendingOpenshiftApprovalsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof DashboardApiDashboardPendingOpenshiftApprovalsGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {string}
     * @memberof DashboardApiDashboardPendingOpenshiftApprovalsGet
     */
    readonly positionId?: string

    /**
     * 
     * @type {string}
     * @memberof DashboardApiDashboardPendingOpenshiftApprovalsGet
     */
    readonly version?: string
}

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @param {DashboardApiDashboardArrivalsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardArrivalsGet(requestParameters: DashboardApiDashboardArrivalsGetRequest = {}, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardArrivalsGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.payDate, requestParameters.positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiDashboardCalloffsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardCalloffsGet(requestParameters: DashboardApiDashboardCalloffsGetRequest, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardCalloffsGet(requestParameters.startDate, requestParameters.endDate, requestParameters.departmentId, requestParameters.positionId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiDashboardDeparturesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardDeparturesGet(requestParameters: DashboardApiDashboardDeparturesGetRequest = {}, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardDeparturesGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.payDate, requestParameters.positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiDashboardHppdHoursGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardHppdHoursGet(requestParameters: DashboardApiDashboardHppdHoursGetRequest = {}, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardHppdHoursGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiDashboardOverVsUnderByPositionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardOverVsUnderByPositionPost(requestParameters: DashboardApiDashboardOverVsUnderByPositionPostRequest = {}, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardOverVsUnderByPositionPost(requestParameters.overVsUnderByPositionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiDashboardOverVsUnderGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardOverVsUnderGet(requestParameters: DashboardApiDashboardOverVsUnderGetRequest, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardOverVsUnderGet(requestParameters.startDate, requestParameters.endDate, requestParameters.departmentId, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiDashboardPendingAbsenceRequestsCountGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardPendingAbsenceRequestsCountGet(requestParameters: DashboardApiDashboardPendingAbsenceRequestsCountGetRequest = {}, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardPendingAbsenceRequestsCountGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiDashboardPendingOpenshiftApprovalsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public dashboardPendingOpenshiftApprovalsGet(requestParameters: DashboardApiDashboardPendingOpenshiftApprovalsGetRequest = {}, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).dashboardPendingOpenshiftApprovalsGet(requestParameters.departmentId, requestParameters.positionId, requestParameters.version, options).then((request) => request(this.axios, this.basePath));
    }
}
